import React from 'react';
import SliderWrapper from 'jd-library/SliderWrapper'
import historyHandler from 'jd-library/historyHandler';
import SortItemList from './SortItemList';
import './sort-item-list.scss';

const SortItemSlider = (props) => {
    const {
		items,
		moveOption,
        onHidden,
        onSave
	} = props;

    return (
        <SliderWrapper
            header={{
                heading: 'Sort Image',
                subHeading: '',
                variant: 'secondary',
                hasBorder: true,
                leftIcons: [
                    {
                        className: 'icon-key-left',
                        onClick: () => historyHandler.closeCurrent()
                    }
                ]
            }}
            footer={{
                btnProps: [
                    {
                        children: 'Save',
                        onClick: () => {
                            onSave();
                        }
                    }]
            }}
            onHidden={()=> onHidden()}
        >
            <div className="sort-item-container" >
                <SortItemList
                    items={items}
                    moveOption={moveOption}
                />
            </div>
        </SliderWrapper>
    )
}

export default SortItemSlider